import "../styles/buttonMoreInfo.css";

function ButtonMoreInfo() {
  return (
    <button className="button_moreInfo">
      More info
      <div className="arrow-wrapper">
        <div className="arrow"></div>
      </div>
    </button>
  );
}

export default ButtonMoreInfo;
